const ChevronDownIcon = ({ size = 24, className }) => {
  return (
    <img
      src={require("../../../assets/images/chevron-down.svg").default}
      alt="chevron down"
      width={size}
      className={className}
    />
  );
};
export default ChevronDownIcon;
